import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/backstage/logo.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "user" }
const _hoisted_4 = { class: "el-dropdown-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "logo" }, [
      _createElementVNode("img", {
        style: {"height":"0.4rem"},
        src: _imports_0,
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_avatar, null, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" user ", -1)
          ]))]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_dropdown, null, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  divided: "",
                  onClick: _ctx.loginout
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("退出登录", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.userInfo.realName) + " ", 1),
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "iconfont icon-xiala" }, null, -1))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}